if (!customElements.get("free-trial-slider")) {
  customElements.define(
    "free-trial-slider",
    class FreeTrialSlider extends HTMLElement {
      constructor() {
        super();

        this.init();
        this.numberOfSlides;
      }

      init() {
        // attach evt listeners for click
        this.addEventListener("click", this.handleClickEvt.bind(this));
        this.numberOfSlides = this.querySelectorAll("[data-index]").length;
      }

      handleClickEvt(e) {
        if (
          e.target.closest("[data-next]") == null &&
          e.target.closest("[data-previous]") == null
        )
          return;

        const currentIndex = parseInt(
          e.target.closest("[data-index]").dataset.index
        );
        const prevIndex = currentIndex - 1;
        const nextIndex = currentIndex + 1;

        if (e.target.closest("[data-next]")) {
          this.goToSlide(currentIndex, nextIndex);
        }

        if (e.target.closest("[data-previous]")) {
          this.goToSlide(currentIndex, prevIndex);
        }
      }

      goToSlide(currentIndex, nextIndex) {
        // loop round
        if (nextIndex == 0) nextIndex = this.numberOfSlides;
        if (nextIndex > this.numberOfSlides) nextIndex = 1;

        this.querySelector(`[data-index="${currentIndex}"]`).classList.add(
          "hidden"
        );
        this.querySelector(`[data-index="${nextIndex}"]`).classList.remove(
          "hidden"
        );
      }
    }
  );
}
